module.exports = __webpack_public_path__ + "media/packs/images/flags/AU-482cd7d7ffc043328ca505484f70b5dd.svg";